import { Button } from '@toggle/design-system';
import styled from 'styled-components';

export const SubmitButton = styled(Button).attrs({
  variant: 'primary',
  size: 'xsmall',
})<{ $active: boolean; $hasMultipleRow?: boolean }>`
  position: absolute;
  top: ${({ $hasMultipleRow }) => !$hasMultipleRow && '18px'};
  right: 16px;
  background: var(--background-soft);
  align-self: flex-end;
  &:hover {
    background: var(--background-soft);
  }

  svg path {
    fill: var(--icon-disabled);
    ${({ $active }) =>
      $active &&
      `
      fill: var(--icon-default);
    `}
  }
`;
